import { create } from 'zustand';

interface TenantLifecycleState {
  /**
   * Set true when the API returns 403 TENANT_DEACTIVATED (TDEV-571 A4). This is a
   * tenant-level block, NOT a session expiry — a re-login can't clear it — so it
   * lives in its own dashboard-local flag rather than the shared session store's
   * expiry state machine. The app renders a dedicated "account deactivated" page
   * while it's set.
   */
  deactivated: boolean;
  setDeactivated: () => void;
  /** Cleared when a recovery probe succeeds (support reactivated the tenant). */
  clearDeactivated: () => void;
}

export const useTenantLifecycleStore = create<TenantLifecycleState>((set) => ({
  deactivated: false,
  setDeactivated: () => set({ deactivated: true }),
  clearDeactivated: () => set({ deactivated: false }),
}));
